import script from "./BlogHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogHeader.vue?vue&type=script&lang=ts&setup=true"

import "./BlogHeader.vue?vue&type=style&index=0&id=e3f54e74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f54e74"]])

export default __exports__